const detectObtrusiveScrollbars = () => {
  // https://www.filamentgroup.com/lab/scrollbars/
  const parent = document.createElement('div');
  parent.setAttribute('style', 'width:30px;height:30px;overflow:auto;');

  const child = document.createElement('div');
  child.setAttribute('style', 'width:100%;height:40px;');
  parent.appendChild(child);
  document.body.appendChild(parent);

  // Measure the child element, if it is not
  // 30px wide the scrollbars are obtrusive.
  const obtrusive = !!(30 - parent.firstChild.clientWidth);

  document.body.removeChild(parent);

  return obtrusive;
};

export default detectObtrusiveScrollbars();
